import { InlineTranslateable } from '@fmnts/i18n';
import { ConditionDefinition } from '../condition/conditions';
import { FieldDeclaration } from './field-declaration';
import { FormDeclarationNode } from './form-declaration-tree';
import { FieldsetDefinition } from './form.types';

export class FieldsetDeclaration implements FieldsetDefinition {
  readonly key: string;
  readonly label: InlineTranslateable;
  readonly condition?: ConditionDefinition | undefined;
  readonly fields: ReadonlyArray<FieldDeclaration>;

  constructor(dto: Readonly<FieldsetDefinition>) {
    this.key = dto.key;
    this.fields = dto.fields;
    this.label = dto.label;
    this.condition = dto.condition;
  }
}

/**
 * Type Guard for Fieldsets
 *
 * @param value
 * @returns
 */
export function isFieldsetDeclaration(
  value: FormDeclarationNode,
): value is FieldsetDeclaration {
  return (
    value instanceof FieldsetDeclaration ||
    ('fields' in value && Array.isArray(value['fields']))
  );
}
